import { HomeOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import React, { ReactElement } from 'react';

import classes from './NotFound.module.css';

interface NotExistsProps {
  entityType?: string;
  message?: string;
  backUrl?: string;
  backLabel?: string;
}

export default function NotExists({
  entityType = 'Resource',
  message,
  backUrl = '/orgs',
  backLabel = 'Back to Home',
}: NotExistsProps): ReactElement {
  const defaultMessage = `The ${entityType.toLowerCase()} you're looking for doesn't exist or you don't have access to it.`;

  return (
    <div className={classes.container}>
      <div className={classes.content}>
        <div className={classes.errorCode}>404</div>
        <h1 className={classes.title}>{entityType} Not Found</h1>
        <p className={classes.description}>{message || defaultMessage}</p>
        <Button size="large" href={backUrl} icon={<HomeOutlined />} className={classes.button}>
          {backLabel}
        </Button>
      </div>
    </div>
  );
}
